import { TextEntryFilterOption } from '../types';
import { GeneCSVEntry } from '../../components';

export const config: TextEntryFilterOption = {
  id: 'omicsExplorer.filters.gene',
  title: {
    id: 'omicsExplorer.filters.gene',
    defaultMessage: 'Gene',
  },
  content: GeneCSVEntry,
  injectedProps: {
    textEntryOption: {
      id: 'omicsExplorer.filters.gene',
      searchValue: '',
      placeholderIntlLabel: {
        id: 'omicsExplorer.filters.gene.placeholderLabel',
        defaultMessage: 'Add (comma-separated)',
      },
    },
  },
};
